export const API_BASE_URL = process.env.REACT_APP_TVC_API_URL;

export const ROLES = {
  ADMIN: "Admin",
  MANAGER: "Manager",
  STAFF: "Staff",
};

export const ROLE_OPTIONS = [
  { value: "Admin", label: "Admin" },
  { value: "Manager", label: "Manager" },
  { value: "Staff", label: "Staff" },
];

export const COUNTRY_CODES = [
  { value: "+1", label: "+1 (US/CA)" },
  { value: "+44", label: "+44 (UK)" },
  { value: "+91", label: "+91 (India)" },
  { value: "+61", label: "+61 (Australia)" },
  { value: "+81", label: "+81 (Japan)" },
  { value: "+86", label: "+86 (China)" },
  { value: "+49", label: "+49 (Germany)" },
  { value: "+33", label: "+33 (France)" },
  { value: "+39", label: "+39 (Italy)" },
  { value: "+34", label: "+34 (Spain)" },
  { value: "+55", label: "+55 (Brazil)" },
  { value: "+7", label: "+7 (Russia)" },
  { value: "+82", label: "+82 (South Korea)" },
  { value: "+65", label: "+65 (Singapore)" },
  { value: "+971", label: "+971 (UAE)" },
  { value: "+966", label: "+966 (Saudi Arabia)" },
  { value: "+352", label: "+352 (Luxembourg)" },
  { value: "+41", label: "+41 (Switzerland)" },
  { value: "+31", label: "+31 (Netherlands)" },
];

export const CHANGE_REQUEST_STATUS = {
  PENDING_MANAGER: "pending_manager",
  PENDING_ADMIN: "pending_admin",
  MANAGER_APPROVED: "manager_approved",
  ADMIN_APPROVED: "admin_approved",
  REJECTED: "rejected",
};

export const STATUS_LABELS = {
  pending: "Pending",
  active: "Active",
  rejected: "Rejected",
  pending_manager: "Pending Manager Approval",
  pending_admin: "Awaiting For Decision",
  manager_approved: "Pending",
  admin_approved: "Pending",
};

export const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export const formatDateOnly = (dateStr) => {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  const day = d.getDate();
  const month = MONTHS[d.getMonth()];
  const year = d.getFullYear();
  return `${day} ${month} ${year}`;
};

export const FOOTER_SHEET_URL = "https://docs.google.com/spreadsheets/d/1F5k9BNRVMy9chxJmF9l9x_O1eAvn3PNaGW7W_23Lop0/edit?usp=sharing";

export const FOOTER_SECTION_KEY = "footer";

export const FOOTER_TABS = [
  { id: "socials", label: "Social Links" },
  { id: "headings", label: "Headings" },
  { id: "brand", label: "Brand Info" },
  { id: "data", label: "Data" },
];

const slugify = (text) => {
  if (!text) return "/";
  return "/" + text
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
};

export const autoGenerateUrls = (content, fields = []) => {
  if (!content) return content;
  const updated = { ...content };
  for (const field of fields) {
    if (Array.isArray(updated[field])) {
      updated[field] = updated[field].map((item) => ({
        ...item,
        href: item.href || slugify(item.label),
      }));
    }
  }
  return updated;
};

export const FOOTER_COLUMNS = {
  socials: [
    { key: "icon", label: "Icon Name", type: "icon", kindKey: "iconKind" },
    { key: "href", label: "URL" },
    { key: "label", label: "Label" },
  ],
};

export const FOOTER_BRAND_FIELDS = [
  { key: "logoImage", label: "Logo Image URL", placeholder: "https://example.com/logo.png" },
  { key: "logoGif", label: "Logo GIF", placeholder: "https://example.com/logo.gif" },
  { key: "logoMainText", label: "Logo Main Text" },
  { key: "logoSubText", label: "Logo Sub Text" },
  { key: "quote", label: "Brand Quote", type: "textarea" },
  { key: "copyright", label: "Copyright Text" },
  { key: "tagline", label: "Tagline" },
];

export const FOOTER_HEADING_FIELDS = [
  { key: "company", label: "Company Heading" },
  { key: "features", label: "Features Heading" },
  { key: "office", label: "Office Heading" },
];

export const HEADING_SECTION_COLUMNS = [
  { key: "label", label: "Label" },
  { key: "href", label: "URL" },
  { key: "sectionId", label: "Section ID (optional)" },
  { key: "description", label: "Description" },
];

export const HEADING_SECTION_OFFICE_COLUMNS = [
  { key: "icon", label: "Icon", type: "icon", kindKey: "iconKind" },
  { key: "text", label: "Text" },
];

export const FOOTER_MESSAGES = {
  loading: "Loading footer content...",
  noContent: "No footer content found.",
  apiError: "API returned no content data.",
  connectionError: "Cannot connect to backend server. Make sure the API is running.",
  invalidJson: "Invalid JSON - changes won't save until fixed",
  emptyArray: 'No items. Click "Add Row" to create one.',
  submitSuccessAdmin: "Changes published live successfully!",
  submitSuccess: "Changes submitted for approval successfully!",
  submitFailed: "Failed to submit changes.",
  publishing: "Publishing...",
  publishChanges: "Publish Changes",
};

export const VISA_DETAIL_SHEET_URL = process.env.REACT_APP_VISA_DETAIL_SHEET_URL || "https://docs.google.com/spreadsheets/d/1qN6j7jyz1irZMnNekzaa3TFmKs2BJeezAw_DniIwIWg/edit?usp=sharing";
export const VISA_DETAIL_SECTION_KEY = "visaDetail";
export const VISA_DETAIL_TABS = [
  { id: "resources", label: "Resources" },
  { id: "visaOffices", label: "Visa Offices" },
  { id: "embassies", label: "Embassies" },
  { id: "visaForms", label: "Visa Form" },
  { id: "location", label: "Location" },
  { id: "data", label: "Data" }
];
export const VISA_DETAIL_COLUMNS = {
  resources: [
    { key: "title", label: "Heading" },
  ],
  visaOffices: [
    { key: "state", label: "State" },
    { key: "city", label: "City" },
    { key: "office_name", label: "Office Name" },
    { key: "office_type", label: "Type" },
    { key: "address", label: "Address" },
    { key: "phone", label: "Phone" },
    { key: "email", label: "Email" },
    { key: "website", label: "Website" },
    { key: "working_hours", label: "Hours" },
    { key: "services", label: "Services", type: "tags" },
  ],
  embassies: [
    { key: "country", label: "Country" },
    { key: "city", label: "City" },
    { key: "state", label: "State" },
    { key: "embassy_name", label: "Embassy Name" },
    { key: "embassy_type", label: "Mission Type" },
    { key: "address", label: "Address" },
    { key: "phone", label: "Phone" },
    { key: "email", label: "Email" },
    { key: "website", label: "Website" },
    { key: "working_hours", label: "Hours" },
    { key: "visa_types", label: "Visa Categories", type: "tags" },
  ],
  visaForms: [
    { key: "country", label: "Country" },
    { key: "form_name", label: "Form Name" },
    { key: "description", label: "Description" },
    { key: "form_url", label: "Form URL" },
    { key: "tags", label: "Tags", type: "tags" },
  ],
  states: [
    { key: "name", label: "Name" },
  ],
  countries: [
    { key: "name", label: "Name" },
  ],
  visaOfficeTypes: [
    { key: "name", label: "Type Name" },
  ],
  embassyTypes: [
    { key: "name", label: "Type Name" },
  ],
};

export const VISA_DETAIL_MESSAGES = {
  loading: "Loading visa detail content...",
  noContent: "No visa detail content found.",
  apiError: "API returned no content data.",
  connectionError: "Cannot connect to backend server. Make sure the API is running.",
  invalidJson: "Invalid JSON - changes won't save until fixed",
  emptyArray: 'No items. Click "Add Row" to create one.',
  submitSuccessAdmin: "Changes published live successfully!",
  submitSuccess: "Changes submitted for approval successfully!",
  submitFailed: "Failed to submit changes.",
  publishing: "Publishing...",
  publishChanges: "Publish Changes",
};

export const REFUND_POLICY_SHEET_URL = process.env.REACT_APP_REFUND_POLICY_SHEET_URL || "https://docs.google.com/spreadsheets/d/1FKK19DVIlgdMc4SyUhxjwGSVrkdVwnIqn9rdILMqnjA/edit?usp=sharing";
export const REFUND_POLICY_SECTION_KEY = "refundPolicy";
export const REFUND_POLICY_TABS = [
  { id: "productTabs", label: "Product Tabs" },
  { id: "policyStages", label: "Policy Stages" },
  { id: "testimonials", label: "Testimonials" },
  { id: "data", label: "Data" }
];
export const REFUND_POLICY_COLUMNS = {
  productTabs: [
    { key: "label", label: "Label" },
    { key: "description", label: "Description", type: "textarea" }
  ],
  testimonials: [
    { key: "name", label: "Full Name" },
    { key: "initials", label: "Initials" },
    { key: "location", label: "Location" },
    { key: "date", label: "Date" },
    { key: "rating", label: "Rating", type: "select", options: ["1", "2", "3", "4", "5"] },
    { key: "tag", label: "Tag" },
    { key: "review", label: "Review", type: "textarea" }
  ]
};
export const REFUND_POLICY_MESSAGES = {
  loading: "Loading refund policy content...",
  noContent: "No refund policy content found.",
  apiError: "API returned no content data.",
  connectionError: "Cannot connect to backend server. Make sure the API is running.",
  invalidJson: "Invalid JSON - changes won't save until fixed",
  emptyArray: 'No items. Click "Add Row" to create one.',
  submitSuccessAdmin: "Changes published live successfully!",
  submitSuccess: "Changes submitted for approval successfully!",
  submitFailed: "Failed to submit changes.",
  publishing: "Publishing...",
  publishChanges: "Publish Changes",
};

export const getSubmitButtonLabel = (role) => {
  if (role === "Admin") return "Publish";
  return "Submit";
};

export const getContentUpdateDescription = (sectionLabel) => `Content update: ${sectionLabel}`;

export const GOVERNMENT_FEE_SHEET_URL = process.env.REACT_APP_GOVERNMENT_FEE_SHEET_URL || "https://docs.google.com/spreadsheets/d/1K8dfaPxtIDls0qnDNHZnJqLfM7iSoSaqq7gJEoTLn7s/edit?usp=sharing";
export const GOVERNMENT_FEE_SECTION_KEY = "governmentFee";
export const GOVERNMENT_FEE_TABS = [
  { id: "data", label: "Data" },
];
export const GOVERNMENT_FEE_MESSAGES = {
  loading: "Loading government fee content...",
  noContent: "No government fee content found.",
  apiError: "API returned no content data.",
  connectionError: "Cannot connect to backend server. Make sure the API is running.",
  invalidJson: "Invalid JSON - changes won't save until fixed",
  submitSuccessAdmin: "Changes published live successfully!",
  submitSuccess: "Changes submitted for approval successfully!",
  submitFailed: "Failed to submit changes.",
  publishing: "Publishing...",
  publishChanges: "Publish Changes",
};

export const REQUIREMENTS_SHEET_URL = process.env.REACT_APP_REQUIREMENTS_SHEET_URL || "https://docs.google.com/spreadsheets/d/1BZVM5tRWBxEMTPajQseo5ASezmsTFI4gBjwx-C1Qe9I/edit?usp=sharing";
export const REQUIREMENTS_SECTION_KEY = "requirements";
export const REQUIREMENTS_TABS = [
  { id: "visaMetaGrid", label: "Visa Meta" },
  { id: "visaRoutes", label: "Visa Routes" },
  { id: "visaFlags", label: "Visa Flags" },
  { id: "fallbackDocs", label: "Essential Docs" },
  { id: "requiredDocs", label: "Required Docs" },
  { id: "loaderCheckpoints", label: "Loader Checkpoints" },
  { id: "applicationTips", label: "Application Tips" },
  { id: "processingBadges", label: "Processing Badges" },
  { id: "countries", label: "Countries" },
  { id: "data", label: "Data" },
];
export const REQUIREMENTS_COLUMNS = {
  visaMetaGrid: [
    { key: "key", label: "Meta Key" },
    { key: "label", label: "Label" },
  ],
  visaRoutes: [
    { key: "passportName", label: "Passport Name" },
    { key: "destinationName", label: "Destination Name" },
    { key: "processingTime", label: "Processing Time" },
    { key: "visaMeta", label: "Visa Meta", type: "metaSelect" },
  ],
  requiredDocs: [
    { key: "label", label: "Label" },
    { key: "description", label: "Description", type: "textarea" },
  ],
  fallbackDocs: [
    { key: "label", label: "Label" },
    { key: "detail", label: "Detail", type: "textarea" },
  ],
  loaderCheckpoints: [
    { key: "label", label: "Step Label" },
    { key: "pct", label: "Percentage (0-100)" },
  ],
  countries: [
    { key: "name", label: "Name" },
    { key: "region", label: "Region" },
  ],
};
export const REQUIREMENTS_MESSAGES = {
  loading: "Loading requirements content...",
  noContent: "No requirements content found.",
  apiError: "API returned no content data.",
  connectionError: "Cannot connect to backend server. Make sure the API is running.",
  invalidJson: "Invalid JSON - changes won't save until fixed",
  emptyArray: 'No items. Click "Add Row" to create one.',
  submitSuccessAdmin: "Changes published live successfully!",
  submitSuccess: "Changes submitted for approval successfully!",
  submitFailed: "Failed to submit changes.",
  publishing: "Publishing...",
  publishChanges: "Publish Changes",
};
export const REQUIREMENTS_DUPLICATE_CHECK = [
  { field: "visaRoutes", fullRow: true, keyFields: ["passportName", "destinationName"], tabId: "visaRoutes", tabLabel: "Visa Routes" },
  { field: "fallbackDocs", fullRow: true, keyFields: ["key", "detail"], tabId: "fallbackDocs", tabLabel: "Fallback Docs" },
  { field: "loaderCheckpoints", fullRow: true, keyFields: ["label", "pct"], tabId: "loaderCheckpoints", tabLabel: "Loader Checkpoints" },
];

export const VISA_CAREER_SHEET_URL = process.env.REACT_APP_VISA_CAREER_SHEET_URL || "https://docs.google.com/spreadsheets/d/1jSpf8U77RlmBwf4LEOZBpx1-mXwwllO1NmkWQhyh8pY/edit?usp=sharing";
export const VISA_CAREER_SECTION_KEY = "visaCareer";
export const VISA_CAREER_TABS = [
  { id: "departments", label: "Departments" },
  { id: "culture", label: "Culture / Values" },
  { id: "howHiringWorks", label: "How Hiring Works" },
  { id: "whyVisaCo", label: "Why The Visa Co?" },
  { id: "roleOverviewLabels", label: "Role Overview Labels" },
  { id: "jobListings", label: "Job Listings" },
  { id: "benefits", label: "Life at The Visa Co" },
  { id: "filter", label: "Filter" },
  { id: "formFields", label: "Form Fields" },
  { id: "countryCodes", label: "Country Codes" },
  { id: "emailSettings", label: "Email Info" },
  { id: "data", label: "Data" },
];
export const VISA_CAREER_COLUMNS = {
  departments: [
    { key: "id", label: "Department ID" },
    { key: "label", label: "Department Label" },
  ],
  culture: [
    { key: "title", label: "Title" },
    { key: "description", label: "Description", type: "textarea" },
  ],
  howHiringWorks: [
    { key: "step", label: "Step #" },
    { key: "title", label: "Title" },
    { key: "description", label: "Description", type: "textarea" },
  ],
  whyVisaCo: [
    { key: "0", label: "Reason (plain text)", singleField: true },
  ],
  roleOverviewLabels: [
    { key: "0", label: "Label (plain text)", singleField: true },
  ],
  jobListings: [
    { key: "id", label: "Job ID", readonly: true },
    { key: "title", label: "Job Title" },
    { key: "department", label: "Department ID", type: "departmentSelect" },
    { key: "departmentLabel", label: "Department Label", readonly: true },
    { key: "location", label: "Location" },
    { key: "type", label: "Type", type: "dynamicSelect" },
    { key: "experience", label: "Experience" },
    { key: "postedDate", label: "Posted Date", type: "date" },
    { key: "description", label: "Description", type: "textarea" },
    { key: "requirements", label: "Requirements", type: "textarea" },
    { key: "role", label: "The Role", type: "textarea" },
    { key: "idealCandidate", label: "Ideal Candidate", type: "textarea" },
  ],
  benefits: [
    { key: "title", label: "Title" },
    { key: "description", label: "Description", type: "textarea" },
  ],
  sortOptions: [
    { key: "value", label: "Value" },
    { key: "label", label: "Label" },
  ],
  locationOptions: [
    { key: "value", label: "Value" },
    { key: "label", label: "Label" },
  ],
  jobTypeOptions: [
    { key: "value", label: "Value" },
    { key: "label", label: "Label" },
  ],
  formFields: [
    { key: "key", label: "Field Key" },
    { key: "label", label: "Label" },
    { key: "required", label: "Required", type: "select", options: ["Yes", "No"] },
    { key: "placeholder", label: "Placeholder" },
    { key: "type", label: "Type", type: "select", options: ["text", "number", "word+number", "file"] },
  ],
  countryCodes: [
    { key: "countryName", label: "Country" },
    { key: "code", label: "Code (+91)" },
    { key: "label", label: "Label (IN +91)" },
  ],
};
export const VISA_CAREER_MESSAGES = {
  loading: "Loading visa career content...",
  noContent: "No visa career content found.",
  apiError: "API returned no content data.",
  connectionError: "Cannot connect to backend server. Make sure the API is running.",
  invalidJson: "Invalid JSON - changes won't save until fixed",
  emptyArray: 'No items. Click "Add Row" to create one.',
  submitSuccessAdmin: "Changes published live successfully!",
  submitSuccess: "Changes submitted for approval successfully!",
  submitFailed: "Failed to submit changes.",
  publishing: "Publishing...",
  publishChanges: "Publish Changes",
};
export const VISA_CAREER_DUPLICATE_CHECK = [
  { field: "departments", fullRow: true, keyFields: ["id", "label"], tabId: "departments", tabLabel: "Departments" },
  { field: "culture", fullRow: true, keyFields: ["icon", "title", "description"], tabId: "culture", tabLabel: "Culture" },
  { field: "howHiringWorks", fullRow: true, keyFields: ["step", "title", "description"], tabId: "howHiringWorks", tabLabel: "How Hiring Works" },
  { field: "whyVisaCo", fullRow: true, keyFields: [], tabId: "whyVisaCo", tabLabel: "Why The Visa Co?" },
  { field: "roleOverviewLabels", fullRow: true, keyFields: [], tabId: "roleOverviewLabels", tabLabel: "Role Overview Labels" },
  { field: "jobListings", fullRow: true, keyFields: ["title", "department", "location", "type", "experience", "description", "requirements", "role", "idealCandidate"], tabId: "jobListings", tabLabel: "Job Listings" },
  { field: "benefits", fullRow: true, keyFields: ["icon", "title", "description"], tabId: "benefits", tabLabel: "Benefits" },
  { field: "sortOptions", fullRow: true, keyFields: ["value", "label"], tabId: "sortOptions", tabLabel: "Sort Options" },
  { field: "locationOptions", fullRow: true, keyFields: ["value", "label"], tabId: "locationOptions", tabLabel: "Location Options" },
  { field: "jobTypeOptions", fullRow: true, keyFields: ["value", "label"], tabId: "jobTypeOptions", tabLabel: "Job Type Options" },
  { field: "countryCodes", fullRow: true, keyFields: ["code", "label", "countryName"], tabId: "countryCodes", tabLabel: "Country Codes" },
];
export const ROLE_OVERVIEW_LABEL_OPTIONS = [
  "Job Title",
  "Department Label",
  "Location",
  "Type",
  "Experience",
  "Posted Date",
];

export const VISA_CAREER_ICON_PRESETS = ["whatsapp", "profile", "calendar", "phone", "contact", "globe", "zap", "users", "lightbulb", "heart", "trendingUp", "wifi", "plane", "book", "shield", "dollar", "gift", "clock", "building"];
export const VISA_CAREER_EMAIL_DEFAULTS = {
  jobSubject: "Application Received — TheVisaCo Careers",
  jobBody: "Hi {{ applicantName }},\n\nThank you for applying for the {{ jobTitle }} role at TheVisaCo. We're excited to review your application!\n\nOur Talent team will review your application and get back to you within 5–7 business days. If your profile matches what we're looking for, we'll reach out to schedule a conversation.\n\nBest regards,\nThe TheVisaCo Talent Team",
  adminJobSubject: "New Job Application — {{ jobTitle }}",
  adminJobBody: "New job application received\n\nPosition: {{ jobTitle }}\nApplicant Name: {{ applicantName }}\nEmail: {{ applicantEmail }}\nPhone: {{ phone }}\nExperience: {{ experience }}\nLinkedIn: {{ linkedIn }}\nCover Note: {{ coverNote }}\nResume: {{ resumeUrl }}",
  acceptanceSubject: "You're Accepted — TheVisaCo",
  acceptanceBody: "Hi {{ applicantName }},\n\nCongratulations! We are delighted to inform you that you have been accepted for the {{ jobTitle }} role at TheVisaCo.\n\nWe were impressed with your background and believe you will be a great addition to our team. Someone from our HR team will reach out to you shortly with the next steps.\n\nWelcome to TheVisaCo!\n\nBest regards,\nThe TheVisaCo Talent Team",
  adminAcceptanceSubject: "Application Accepted — {{ jobTitle }}",
  adminAcceptanceBody: "Job application accepted\n\nPosition: {{ jobTitle }}\nApplicant Name: {{ applicantName }}\nEmail: {{ applicantEmail }}\nPhone: {{ phone }}\n\nView in admin panel:\n{{ adminUrl }}",
  rejectionSubject: "Update on Your Application — TheVisaCo",
  rejectionBody: "Hi {{ applicantName }},\n\nThank you for your interest in the {{ jobTitle }} role at TheVisaCo and for taking the time to apply.\n\nAfter careful review, we regret to inform you that we have decided to move forward with other candidates whose qualifications more closely match our current needs.\n\nWe truly appreciate your interest and wish you the very best in your job search.\n\nBest regards,\nThe TheVisaCo Talent Team",
  adminRejectionSubject: "Application Rejected — {{ jobTitle }}",
  adminRejectionBody: "Job application rejected\n\nPosition: {{ jobTitle }}\nApplicant Name: {{ applicantName }}\nEmail: {{ applicantEmail }}\nPhone: {{ phone }}\n\nView in admin panel:\n{{ adminUrl }}",
};

export const SCHEDULE_MEETING_SHEET_URL = process.env.REACT_APP_SCHEDULE_MEETING_SHEET_URL || "https://docs.google.com/spreadsheets/d/1iXmJw6LP9en74tFhpGgVP45E9wEQnGnZHXcT4C_1pI0/edit?usp=sharing";
export const MEETING_BOOKINGS_SHEET_URL = process.env.REACT_APP_MEETING_BOOKINGS_SHEET_URL || "https://docs.google.com/spreadsheets/d/1GJ9TzBtPwF_Q7hPCGKBWsIaIe4vA2EL5004EGrwHUQA/edit?usp=sharing";
export const JOB_APPLICATIONS_SHEET_URL = process.env.REACT_APP_JOB_APPLICATIONS_SHEET_URL || "https://docs.google.com/spreadsheets/d/1et0lRX_CCUvOI1lPwVEf33HDYpUMreaJQP4Uq77NtZY/edit?usp=sharing";
export const REVIEWS_SHEET_URL = process.env.REACT_APP_REVIEWS_SHEET_URL || "https://docs.google.com/spreadsheets/d/18qejM7-Cvdt5-axFpU4kL0MWkxyM79RBUy9uynyXz2w/edit?usp=sharing";
export const SCHEDULE_MEETING_SECTION_KEY = "scheduleMeeting";
export const SCHEDULE_MEETING_TABS = [
  { id: "meetingTypes", label: "Meeting Types" },
  { id: "durationDateTime", label: "Meeting Duration" },
  { id: "contactDetails", label: "Contact Details" },
  { id: "consentAgreement", label: "Consent & Agreement" },
  { id: "countryCodes", label: "Country Codes" },
  { id: "emailSettings", label: "Email Info" },
  { id: "data", label: "Data" },
];
export const SCHEDULE_MEETING_COLUMNS = {
  meetingTypes: [
    { key: "label", label: "Label" },
    { key: "icon", label: "Icon", type: "icon", kindKey: "iconKind" },
    { key: "description", label: "Description", type: "textarea" },
  ],
  durationPrice: [
    { key: "type", label: "Meeting Type" },
    { key: "duration", label: "Duration (min)" },
    { key: "price", label: "Price", type: "select", options: ["Free", "Paid"] },
  ],
  durations: [
    { key: "label", label: "Label" },
    { key: "desc", label: "Description" },
    { key: "price", label: "Price", type: "select", options: ["Free", "Paid"] },
    { key: "amount", label: "Amount" },
  ],
  slots: [
    { key: "time", label: "Time" },
  ],
  contactDetails: [
    { key: "key", label: "Field Key" },
    { key: "label", label: "Label" },
    { key: "required", label: "Required", type: "select", options: ["Yes", "No"] },
    { key: "placeholder", label: "Placeholder" },
    { key: "type", label: "Type", type: "select", options: ["text", "number", "word+number", "file"] },
  ],
  consentFree: [
    { key: "title", label: "Title" },
    { key: "content", label: "Content", type: "textarea" },
    { key: "type", label: "Type" },
  ],
  consentPaid: [
    { key: "title", label: "Title" },
    { key: "content", label: "Content", type: "textarea" },
    { key: "type", label: "Type" },
  ],
  countryCodes: [
    { key: "countryName", label: "Country" },
    { key: "code", label: "Code (+91)" },
    { key: "label", label: "Label (IN +91)" },
  ],
};
export const SCHEDULE_MEETING_MESSAGES = {
  loading: "Loading schedule meeting content...",
  noContent: "No schedule meeting content found.",
  apiError: "API returned no content data.",
  connectionError: "Cannot connect to backend server. Make sure the API is running.",
  invalidJson: "Invalid JSON - changes won't save until fixed",
  emptyArray: 'No items. Click "Add Row" to create one.',
  submitSuccessAdmin: "Changes published live successfully!",
  submitSuccess: "Changes submitted for approval successfully!",
  submitFailed: "Failed to submit changes.",
  publishing: "Publishing...",
  publishChanges: "Publish Changes",
};
export const SCHEDULE_MEETING_DUPLICATE_CHECK = [
  { field: "meetingTypes", fullRow: true, keyFields: ["type", "label", "description"], tabId: "meetingTypes", tabLabel: "Meeting Types" },
  { field: "durationPrice", fullRow: true, keyFields: ["type", "duration", "price"], tabId: "meetingTypes", tabLabel: "Meeting Types" },
  { field: "durations", fullRow: true, keyFields: ["id", "label", "desc", "price", "amount"], tabId: "durationDateTime", tabLabel: "Meeting Duration" },
  { field: "slots", fullRow: true, keyFields: ["time"], tabId: "durationDateTime", tabLabel: "Meeting Duration" },
  { field: "contactDetails", fullRow: true, keyFields: ["key", "label", "placeholder", "type"], tabId: "contactDetails", tabLabel: "Contact Details" },
  { field: "consentFree", fullRow: true, keyFields: ["title", "content", "type"], tabId: "consentAgreement", tabLabel: "Consent & Agreement" },
  { field: "consentPaid", fullRow: true, keyFields: ["title", "content", "type"], tabId: "consentAgreement", tabLabel: "Consent & Agreement" },
  { field: "countryCodes", fullRow: true, keyFields: ["code", "label", "countryName"], tabId: "countryCodes", tabLabel: "Country Codes" },
];

export const EMAIL_SETTINGS_SECTION_KEY = "emailSettings";
export const EMAIL_SETTINGS_TABS = [
  { id: "general", label: "General Settings" },
  { id: "data", label: "Data" },
];
export const EMAIL_SETTINGS_MESSAGES = {
  loading: "Loading email settings...",
  noContent: "No email settings found.",
  apiError: "API returned no content data.",
  connectionError: "Cannot connect to backend server. Make sure the API is running.",
  invalidJson: "Invalid JSON - changes won't save until fixed",
  submitSuccessAdmin: "Changes published live successfully!",
  submitSuccess: "Changes submitted for approval successfully!",
  submitFailed: "Failed to submit changes.",
  publishing: "Publishing...",
  publishChanges: "Publish Changes",
};

export const SCHEDULE_MEETING_EMAIL_DEFAULTS = {
  meetingSubject: "Meeting Booking Confirmed — TheVisaCo",
  meetingBody: "Hi {{ name }},\n\nYour consultation has been confirmed. Here are the details:\n\nBooking ID: {{ humanId }}\nMeeting Type: {{ meetingType }}\nDate: {{ meetingDate }}\nTime: {{ meetingSlot }}\nDuration: {{ durationMinutes }} minutes\n\nA Google Meet link will be shared with you before the meeting. Please be available 5 minutes early.\n\nNeed to reschedule? Contact us at +91 98100 44015.\n\nBest regards,\nThe TheVisaCo Team",
  adminMeetingSubject: "New Meeting Booking — {{ humanId }}",
  adminMeetingBody: "New meeting booking received\n\nBooking ID: {{ humanId }}\nName: {{ name }}\nEmail: {{ email }}\nPhone: {{ phone }}\n\nMeeting Type: {{ meetingType }}\nDate: {{ meetingDate }}\nTime: {{ meetingSlot }}\nDuration: {{ durationMinutes }} minutes\n\nView in admin panel:\n{{ adminUrl }}",
  meetLinkSubject: "Google Meet Link Available for Your Meeting — TheVisaCo",
  meetLinkBody: "Hi {{ name }},\n\nYour Google Meet link is now available for your upcoming consultation.\n\nBooking ID: {{ humanId }}\nMeeting Type: {{ meetingType }}\nDate: {{ meetingDate }}\nTime: {{ meetingSlot }}\nDuration: {{ durationMinutes }} minutes\n\nJoin using the link below at the scheduled time:\n{{ meetLink }}\n\nPlease be available 5 minutes before the scheduled time with a stable internet connection.\n\nBest regards,\nThe TheVisaCo Team",
  adminMeetLinkSubject: "Admin: Google Meet Link Set — {{ humanId }}",
  adminMeetLinkBody: "Google Meet link has been set for booking {{ humanId }}\n\nCustomer: {{ name }} ({{ email }})\nPhone: {{ phone }}\nDate: {{ meetingDate }} at {{ meetingSlot }}\nType: {{ meetingType }}\nDuration: {{ durationMinutes }} min\n\nMeet Link: {{ meetLink }}\n\nView in admin panel:\n{{ adminUrl }}",
  noShowSubject: "No Show — Meeting Missed — {{ humanId }}",
  noShowBody: "Hi {{ name }},\n\nWe noticed you missed your scheduled consultation.\n\nBooking ID: {{ humanId }}\nMeeting Type: {{ meetingType }}\nDate: {{ meetingDate }}\nTime: {{ meetingSlot }}\nDuration: {{ durationMinutes }} minutes\n\nPlease reschedule at your earliest convenience.\n\nBest regards,\nThe TheVisaCo Team",
  adminNoShowSubject: "Admin: No Show — {{ humanId }}",
  adminNoShowBody: "No Show — {{ humanId }}\n\nCustomer: {{ name }} ({{ email }})\nPhone: {{ phone }}\nDate: {{ meetingDate }} at {{ meetingSlot }}\nType: {{ meetingType }}\nDuration: {{ durationMinutes }} min",
  cancelSubject: "Meeting Cancelled — {{ humanId }}",
  cancelBody: "Hi {{ name }},\n\nYour meeting has been cancelled.\n\nBooking ID: {{ humanId }}\nMeeting Type: {{ meetingType }}\nDate: {{ meetingDate }}\nTime: {{ meetingSlot }}\nDuration: {{ durationMinutes }} minutes\n\nIf you have any questions, please contact us.\n\nBest regards,\nThe TheVisaCo Team",
  adminCancelSubject: "Admin: Meeting Cancelled — {{ humanId }}",
  adminCancelBody: "Meeting Cancelled — {{ humanId }}\n\nCustomer: {{ name }} ({{ email }})\nPhone: {{ phone }}\nDate: {{ meetingDate }} at {{ meetingSlot }}\nType: {{ meetingType }}\nDuration: {{ durationMinutes }} min",
};

export const SCHEDULE_MEETING_DEFAULTS = {
  emailConfig: {
    meetingSubject: "Meeting Booking Confirmed — TheVisaCo",
    meetingBody: "Hi {{ name }},\n\nYour consultation has been confirmed. Here are the details:\n\nBooking ID: {{ humanId }}\nMeeting Type: {{ meetingType }}\nDate: {{ meetingDate }}\nTime: {{ meetingSlot }}\nDuration: {{ durationMinutes }} minutes\n\nA Google Meet link will be shared with you before the meeting. Please be available 5 minutes early.\n\nNeed to reschedule? Contact us at +91 98100 44015.\n\nBest regards,\nThe TheVisaCo Team",
  },
  consentFree: [
    { title: "Purpose (Free)", content: "This consent form is required before booking a free 15-minute consultation session via Google Meet.", type: "paragraph" },
    { title: "1. Service Overview (Free)", content: "I understand that I am booking a free consultation session of up to 15 minutes regarding visa-related services, conducted via Google Meet.", type: "paragraph" },
    { title: "2. Time Limitation (Free)", content: "The session is strictly limited to 15 minutes. Any discussion beyond 15 minutes will require booking a paid consultation session.", type: "paragraph" },
    { title: "3. No Obligation (Free)", content: "I understand that this free session does not obligate me to purchase any further services.", type: "paragraph" },
    { title: "4. No Guarantee Clause (Free)", content: "I understand that this consultation does not guarantee visa approval or any specific outcome. The guidance provided is based on general information and professional experience.", type: "paragraph" },
    { title: "5. Meeting Guidelines (Free)", content: "I will join the meeting on time using the provided Google Meet link. I will ensure a stable internet connection for the session. I will maintain professional and respectful communication. I understand that delays on my part may reduce my consultation time. The session may be ended if guidelines are not followed.", type: "paragraph" },
    { title: "6. Consent & Agreement (Free)", content: "By checking the box below, I confirm that: I have read and understood the terms above. I agree to proceed with the free consultation.", type: "paragraph" },
  ],
  consentPaid: [
    { title: "1. Service Overview (Paid)", content: "I understand that I am booking a paid consultation session exceeding 15 minutes regarding visa-related services, conducted via Google Meet.", type: "paragraph" },
    { title: "2. Session Duration & Charges (Paid)", content: "The first 15 minutes are free. Any consultation beyond 15 minutes will be chargeable as per the applicable rate. Charges will be clearly communicated before proceeding with the extended session.", type: "paragraph" },
    { title: "3. Payment Policy (Paid)", content: "I agree to make the required payment before continuing the session beyond 15 minutes. Payments once made are non-refundable, except in cases where the service is not delivered by the provider.", type: "paragraph" },
    { title: "4. User Responsibility (Paid)", content: "I will join the meeting on time using the provided link. I understand that delays on my part will not extend the session duration.", type: "paragraph" },
    { title: "5. No Guarantee Clause (Paid)", content: "I understand that this consultation does not guarantee visa approval or any specific outcome. Advice is based on current rules and professional judgment.", type: "paragraph" },
    { title: "6. Meeting Guidelines (Paid)", content: "I will maintain professional behavior during the session. I will ensure a quiet environment and stable internet connection. I will not record the session without prior permission. The session may be terminated in case of misconduct or violation of guidelines.", type: "paragraph" },
    { title: "7. Consent & Agreement (Paid)", content: "By checking the box below, I confirm that: I have read and understood all the terms above. I agree to proceed with the paid consultation beyond 15 minutes.", type: "paragraph" },
  ],
  durations: [
    { id: "15min", label: "15 Min", desc: "Quick chat", price: "Free", amount: 0 },
    { id: "30min", label: "30 Min", desc: "Standard consultation", price: "Paid", amount: 1500 },
    { id: "45min", label: "45 Min", desc: "In-depth consultation", price: "Paid", amount: 2500 },
    { id: "60min", label: "60 Min", desc: "Extended session", price: "Paid", amount: 3500 },
  ],
  slots: [
    { time: "9:30 AM" }, { time: "10:00 AM" }, { time: "10:30 AM" }, { time: "11:00 AM" },
    { time: "11:30 AM" }, { time: "12:00 PM" }, { time: "2:00 PM" }, { time: "2:30 PM" },
    { time: "3:00 PM" }, { time: "3:30 PM" }, { time: "4:00 PM" }, { time: "4:30 PM" }, { time: "5:30 PM" },
  ],
  contactDetails: [
    { key: "name", label: "Full Name *", required: "Yes", placeholder: "Your full name", type: "text" },
    { key: "email", label: "Email Address *", required: "Yes", placeholder: "you@email.com", type: "text" },
    { key: "phone", label: "Phone Number *", required: "Yes", placeholder: "98765 43210", type: "number" },
    { key: "country", label: "Country", required: "No", placeholder: "Enter your country name", type: "text" },
    { key: "note", label: "Additional Notes", required: "No", placeholder: "Anything specific you'd like us to prepare for...", type: "text" },
  ],
  durationPrice: [
    { type: "visa-consultation", duration: "30", price: "Free" },
    { type: "document-review", duration: "45", price: "$50" },
    { type: "interview-prep", duration: "60", price: "$75" },
    { type: "application-assistance", duration: "45", price: "$40" },
    { type: "premium-support", duration: "90", price: "$150" },
  ],
  countryCodes: [
    { code: "+1", countryName: "United States", label: "US +1" },
    { code: "+44", countryName: "United Kingdom", label: "UK +44" },
    { code: "+91", countryName: "India", label: "IN +91" },
    { code: "+971", countryName: "United Arab Emirates", label: "UAE +971" },
    { code: "+65", countryName: "Singapore", label: "SG +65" },
    { code: "+61", countryName: "Australia", label: "AU +61" },
    { code: "+49", countryName: "Germany", label: "DE +49" },
    { code: "+33", countryName: "France", label: "FR +33" },
    { code: "+81", countryName: "Japan", label: "JP +81" },
    { code: "+86", countryName: "China", label: "CN +86" },
    { code: "+7", countryName: "Russia", label: "RU +7" },
    { code: "+55", countryName: "Brazil", label: "BR +55" },
    { code: "+82", countryName: "South Korea", label: "KR +82" },
    { code: "+39", countryName: "Italy", label: "IT +39" },
    { code: "+34", countryName: "Spain", label: "ES +34" },
    { code: "+31", countryName: "Netherlands", label: "NL +31" },
    { code: "+46", countryName: "Sweden", label: "SE +46" },
    { code: "+41", countryName: "Switzerland", label: "CH +41" },
    { code: "+352", countryName: "Luxembourg", label: "LU +352" },
    { code: "+353", countryName: "Ireland", label: "IE +353" },
  ],
};

export const getSheetUrl = (sectionKey) => {
  if (sectionKey === 'visaDetail') return VISA_DETAIL_SHEET_URL;
  if (sectionKey === 'refundPolicy') return REFUND_POLICY_SHEET_URL;
  if (sectionKey === 'navbar') return NAVBAR_SHEET_URL;
  if (sectionKey === 'requirements') return REQUIREMENTS_SHEET_URL;
  if (sectionKey === 'visaCareer') return VISA_CAREER_SHEET_URL;
  if (sectionKey === 'scheduleMeeting') return SCHEDULE_MEETING_SHEET_URL;
  if (sectionKey === 'reviews') return REVIEWS_SHEET_URL;
  if (sectionKey === 'governmentFee') return GOVERNMENT_FEE_SHEET_URL;
  if (sectionKey === 'hero') return HERO_SHEET_URL;
  if (sectionKey === 'event') return EVENT_SHEET_URL;
  if (sectionKey === 'passport') return PASSPORT_SHEET_URL;
  return FOOTER_SHEET_URL;
};
export const getNavbarSheetUrl = () => NAVBAR_SHEET_URL;

export const VISA_API_BASE_URL = process.env.REACT_APP_VISA_API_URL;

export const NAVBAR_SHEET_URL = "https://docs.google.com/spreadsheets/d/1FL8iJkRBRvA6OOWLve9TfX62qtGKusnGU2DREN0nFSE/edit?usp=sharing";

export const NAVBAR_SECTION_KEY = "navbar";

export const NAVBAR_TABS = [
  { id: "toolLinks", label: "Tool Links" },
  { id: "toolImages", label: "Tool Images" },
  { id: "tabs", label: "Hero Tabs" },
  { id: "mobileMenuLinks", label: "Mobile Menu" },
  { id: "mobileQuickActions", label: "Quick Actions" },
  { id: "brand", label: "Brand" },
  { id: "whatsapp", label: "WhatsApp" },
  { id: "calendarSettings", label: "Calendar" },
  { id: "data", label: "Data" },
];

export const NAVBAR_COLUMNS = {
  toolLinks: [
    { key: "label", label: "Label" },
    { key: "href", label: "URL" },
    { key: "sectionId", label: "Section ID" },
    { key: "desc", label: "Description" },
    { key: "actionType", label: "Action Type" },
  ],
  tabs: [
    { key: "id", label: "ID" },
    { key: "label", label: "Label" },
    { key: "to", label: "Route" },
    { key: "sectionId", label: "Section ID" },
    { key: "desc", label: "Description" },
    { key: "actionType", label: "Action Type" },
  ],
  mobileMenuLinks: [
    { key: "label", label: "Label" },
    { key: "to", label: "URL" },
    { key: "sectionId", label: "Section ID" },
    { key: "desc", label: "Description" },
    { key: "actionType", label: "Action Type" },
  ],
  mobileQuickActions: [
    { key: "icon", label: "Icon Name", type: "icon", kindKey: "iconKind" },
    { key: "type", label: "Type" },
    { key: "href", label: "Href" },
    { key: "sectionId", label: "Section ID" },
    { key: "desc", label: "Description" },
    { key: "to", label: "Route" },
  ],
};

export const NAVBAR_BRAND_FIELDS = [
  { key: "logoImage", label: "Logo Image" },
  { key: "logoGif", label: "Logo GIF" },
  { key: "logoMainText", label: "Logo Main Text" },
  { key: "logoSubText", label: "Logo Sub Text" },
];

export const NAVBAR_MESSAGES = {
  loading: "Loading navbar content...",
  noContent: "No navbar content found.",
  apiError: "API returned no content data.",
  connectionError: "Cannot connect to backend server. Make sure the API is running.",
  invalidJson: "Invalid JSON - changes won't save until fixed",
  emptyArray: 'No items. Click "Add Row" to create one.',
  submitSuccessAdmin: "Changes published live successfully!",
  submitSuccess: "Changes submitted for approval successfully!",
  submitFailed: "Failed to submit changes.",
  publishing: "Publishing...",
  publishChanges: "Publish Changes",
};

export const VISA_DETAIL_DUPLICATE_CHECK = [
  { field: "resources", keyField: "title", tabId: "resources", tabLabel: "Resources" },
  { field: "resources", nestedField: "links", fullRow: true, keyFields: ["label", "href", "desc"], tabId: "resources", tabLabel: "Resources Links" },
  { field: "visaOffices", fullRow: true, keyFields: ["state", "city", "office_name", "office_type", "address", "phone", "email", "website", "working_hours", "services"], tabId: "visaOffices", tabLabel: "Visa Offices" },
  { field: "embassies", fullRow: true, keyFields: ["country", "city", "state", "embassy_name", "embassy_type", "address", "phone", "email", "website", "working_hours", "visa_types"], tabId: "embassies", tabLabel: "Embassies" },
  { field: "visaForms", fullRow: true, keyFields: ["country", "form_name", "description", "form_url", "tags"], tabId: "visaForms", tabLabel: "Visa Forms" },
  { field: "states", keyField: "name", tabId: "location", tabLabel: "States" },
  { field: "countries", keyField: "name", tabId: "location", tabLabel: "Countries" },
  { field: "visaOfficeTypes", keyField: "name", tabId: "visaOffices", tabLabel: "Visa Office Types" },
  { field: "embassyTypes", keyField: "name", tabId: "embassies", tabLabel: "Embassy Types" },
];

export const REFUND_POLICY_DUPLICATE_CHECK = [
  { field: "productTabs", fullRow: true, keyFields: ["label", "description"], tabId: "productTabs", tabLabel: "Product Tabs" },
  { field: "policyStages", tabKeyField: true, fullRow: true, keyFields: ["stage", "substage", "refundType", "refundStatus", "reason"], tabId: "policyStages", tabLabel: "Policy Stages" },
  { field: "testimonials", fullRow: true, keyFields: ["name", "initials", "location", "date", "rating", "tag", "review"], tabId: "testimonials", tabLabel: "Testimonials" },
];

export const NAVBAR_DUPLICATE_CHECK = [
  { field: "toolLinks", keyField: "label", tabId: "toolLinks", tabLabel: "Tool Links" },
  { field: "tabs", keyField: "label", tabId: "tabs", tabLabel: "Hero Tabs" },
  { field: "mobileMenuLinks", keyField: "label", tabId: "mobileMenuLinks", tabLabel: "Mobile Menu" },
  { field: "mobileQuickActions", keyField: "icon", tabId: "mobileQuickActions", tabLabel: "Quick Actions" },
  { field: "holidays", parent: "calendar", keyField: "name", tabId: "calendarSettings", tabLabel: "Calendar" },
  { field: "religionColorList", parent: "calendar", keyField: "key", tabId: "calendarSettings", tabLabel: "Calendar" },
  { field: "longWeekendNotes", parent: "calendar", keyField: "note", tabId: "calendarSettings", tabLabel: "Calendar" },
];

export const FOOTER_DUPLICATE_CHECK = [
  { field: "socials", keyField: "label", tabId: "socials", tabLabel: "Social Links" },
  { field: "socials", keyField: "iconKind", tabId: "socials", tabLabel: "Social Links" },
  { field: "headingSections", keyField: "heading", tabId: "headings", tabLabel: "Section Headings" },
  { field: "headingSections", nestedField: "rows", keyField: "label", tabId: "headings", tabLabel: "Section Headings" },
  { field: "headingSections", nestedField: "rows", keyField: "text", tabId: "headings", tabLabel: "Section Headings" },
];

export const HERO_SHEET_URL = process.env.REACT_APP_HERO_SHEET_URL || "https://docs.google.com/spreadsheets/d/1hero-placeholder-id/edit?usp=sharing";
export const EVENT_SHEET_URL = process.env.REACT_APP_EVENT_SHEET_URL || "https://docs.google.com/spreadsheets/d/1alYlKPRXE9p9GkvEOy1cCMEpvI1oCRy_NLeHoxslMUk/edit?usp=sharing";
export const PASSPORT_SHEET_URL = process.env.REACT_APP_PASSPORT_SHEET_URL || "https://docs.google.com/spreadsheets/d/1passport-placeholder-id/edit?usp=sharing";

export const HERO_SECTION_KEY = "hero";
export const HERO_TABS = [
  { id: "tabs", label: "Hero Tabs" },
  { id: "data", label: "Data" },
];
export const HERO_COLUMNS = {
  tabs: [
    { key: "id", label: "ID" },
    { key: "label", label: "Label" },
    { key: "to", label: "Route" },
  ],
};
export const HERO_MESSAGES = {
  loading: "Loading hero content...",
  noContent: "No hero content found.",
  apiError: "API returned no content data.",
  connectionError: "Cannot connect to backend server. Make sure the API is running.",
  invalidJson: "Invalid JSON - changes won't save until fixed",
  emptyArray: 'No items. Click "Add Row" to create one.',
  submitSuccessAdmin: "Changes published live successfully!",
  submitSuccess: "Changes submitted for approval successfully!",
  submitFailed: "Failed to submit changes.",
  publishing: "Publishing...",
  publishChanges: "Publish Changes",
};
export const HERO_DUPLICATE_CHECK = [
  { field: "tabs", keyField: "id", tabId: "tabs", tabLabel: "Hero Tabs" },
];

export const EVENT_SECTION_KEY = "event";
export const EVENT_TABS = [
  { id: "calendar", label: "Calendar" },
  { id: "featuredEvents", label: "Featured Events" },
  { id: "categories", label: "Categories" },
  { id: "countries", label: "Countries" },
  { id: "data", label: "Data" },
];
export const EVENT_COLUMNS = {
  featuredEvents: [
    { key: "title", label: "Title" },
    { key: "date", label: "Date" },
    { key: "category", label: "Category" },
    { key: "country", label: "Country" },
    { key: "city", label: "City" },
    { key: "location", label: "Location" },
    { key: "description", label: "Description", type: "textarea" },
    { key: "tag", label: "Tag" },
    { key: "visaRequired", label: "Visa Status", type: "select", options: ["Visa Required", "Visa Free"] },
    { key: "imageUrl", label: "Image", type: "imageUpload" },
  ],
  categories: [
    { key: "id", label: "ID" },
    { key: "label", label: "Label" },
  ],
  visaStatuses: [
    { key: "label", label: "Label" },
    { key: "color", label: "Text Color", type: "color" },
    { key: "bg", label: "BG Color", type: "color" },
    { key: "border", label: "Border Color", type: "color" },
  ],
  countries: [
    { key: "name", label: "Name" },
    { key: "region", label: "Region" },
  ],
};
export const EVENT_MESSAGES = {
  loading: "Loading event content...",
  noContent: "No event content found.",
  apiError: "API returned no content data.",
  connectionError: "Cannot connect to backend server. Make sure the API is running.",
  invalidJson: "Invalid JSON - changes won't save until fixed",
  emptyArray: 'No items. Click "Add Row" to create one.',
  submitSuccessAdmin: "Changes published live successfully!",
  submitSuccess: "Changes submitted for approval successfully!",
  submitFailed: "Failed to submit changes.",
  publishing: "Publishing...",
  publishChanges: "Publish Changes",
};
export const EVENT_DUPLICATE_CHECK = [
  { field: "featuredEvents", fullRow: true, keyFields: ["title", "date", "category"], tabId: "featuredEvents", tabLabel: "Featured Events" },
  { field: "categories", keyField: "id", tabId: "categories", tabLabel: "Categories" },
  { field: "visaStatuses", keyField: "id", tabId: "visaStatuses", tabLabel: "Visa Statuses" },
];

export const PASSPORT_SECTION_KEY = "passport";
export const PASSPORT_TABS = [
  { id: "processSteps", label: "Process Steps" },
  { id: "services", label: "Services" },
  { id: "faqItems", label: "FAQ" },
  { id: "data", label: "Data" },
];
export const PASSPORT_COLUMNS = {
  processSteps: [
    { key: "stepNumber", label: "Step #" },
    { key: "title", label: "Title" },
    { key: "description", label: "Description", type: "textarea" },
  ],
  services: [
    { key: "title", label: "Title" },
    { key: "description", label: "Description", type: "textarea" },
  ],
  faqItems: [
    { key: "question", label: "Question" },
    { key: "answer", label: "Answer", type: "textarea" },
  ],
};
export const PASSPORT_MESSAGES = {
  loading: "Loading passport content...",
  noContent: "No passport content found.",
  apiError: "API returned no content data.",
  connectionError: "Cannot connect to backend server. Make sure the API is running.",
  invalidJson: "Invalid JSON - changes won't save until fixed",
  emptyArray: 'No items. Click "Add Row" to create one.',
  submitSuccessAdmin: "Changes published live successfully!",
  submitSuccess: "Changes submitted for approval successfully!",
  submitFailed: "Failed to submit changes.",
  publishing: "Publishing...",
  publishChanges: "Publish Changes",
};
export const PASSPORT_DUPLICATE_CHECK = [
  { field: "processSteps", fullRow: true, keyFields: ["stepNumber", "title"], tabId: "processSteps", tabLabel: "Process Steps" },
  { field: "services", keyField: "title", tabId: "services", tabLabel: "Services" },
  { field: "faqItems", keyField: "question", tabId: "faqItems", tabLabel: "FAQ" },
];

const collectArrays = (content, check) => {
  if (check.tabKeyField) {
    const obj = content?.[check.field] || {};
    return Object.entries(obj).map(([tabId, arr]) => ({ tabId, items: arr }));
  }
  if (check.nestedField) {
    const sections = content?.[check.field] || [];
    return sections.map((s, idx) => ({ sectionIndex: idx, sectionHeading: s?.heading || "", items: s?.[check.nestedField] || [] }));
  }
  let items;
  if (check.parent) {
    items = content?.[check.parent]?.[check.field] || [];
  } else {
    items = content?.[check.field] || [];
  }
  return [{ items }];
};

export const findDuplicates = (content, checkConfig) => {
  const results = [];
  for (const check of checkConfig) {
    if (check.fullRow) {
      const getCompositeKey = (item) =>
        (check.keyFields || [])
          .map((k) => {
            const v = item?.[k];
            return v ? JSON.stringify(v) : "";
          })
          .join("::")
          .toLowerCase();
      const collections = collectArrays(content, check);
      for (const col of collections) {
        const arr = col.items || [];
        const seen = {};
        for (let i = 0; i < arr.length; i++) {
          const item = arr[i];
          if (!item) continue;
          const key = getCompositeKey(item);
          if (key) {
            if (seen[key] !== undefined) {
              const base = {
                tabId: check.tabId,
                tabLabel: check.tabLabel,
                field: check.field,
                existingIndex: seen[key],
                duplicateIndex: i,
              };
              if (check.nestedField) {
                base.nestedField = check.nestedField;
                base.sectionIndex = col.sectionIndex;
                base.sectionHeading = col.sectionHeading || "";
              }
              if (check.parent) base.parent = check.parent;
              if (check.tabKeyField) base.tabKeyField = col.tabId;
              results.push(base);
            } else {
              seen[key] = i;
            }
          }
        }
      }
    } else {
      const collections = collectArrays(content, check);
      for (const col of collections) {
        const arr = col.items || [];
        const seen = {};
        for (let i = 0; i < arr.length; i++) {
          const val = arr[i]?.[check.keyField];
          if (val && val.toString().trim()) {
            const key = val.toString().trim().toLowerCase();
            if (seen[key] !== undefined) {
              const base = {
                tabId: check.tabId,
                tabLabel: check.tabLabel,
                field: check.field,
                keyField: check.keyField,
                duplicateValue: val,
                existingIndex: seen[key],
                duplicateIndex: i,
              };
              if (check.nestedField) {
                base.nestedField = check.nestedField;
                base.sectionIndex = col.sectionIndex;
                base.sectionHeading = col.sectionHeading || "";
              }
              if (check.parent) base.parent = check.parent;
              if (check.tabKeyField) base.tabKeyField = col.tabId;
              results.push(base);
            } else {
              seen[key] = i;
            }
          }
        }
      }
    }
  }
  return results;
};

export const useDuplicateCounts = (content, checkConfig) => {
  const dupes = findDuplicates(content, checkConfig);
  const counts = {};
  for (const d of dupes) {
    counts[d.tabId] = (counts[d.tabId] || 0) + 1;
  }
  return { duplicates: dupes, counts };
};

export const NAV_ITEMS = {
  Admin: [
    { label: "Dashboard", path: "/admin/dashboard", icon: "dashboard" },
    { label: "User Approvals", path: "/admin/user-approvals", icon: "people" },
    {
      label: "Review",
      path: "/admin/refund-ratings",
      icon: "star",
      children: [
        { label: "Refund Review", path: "/admin/refund-ratings", icon: "star" },
      ],
    },
    { label: "Email Settings", path: "/admin/email-settings", icon: "email" },
    {
      label: "Content",
      path: "/admin/content-manager",
      icon: "content",
      children: [
        { label: "Navbar", path: "/admin/navbar-editor", icon: "navbar" },
        { label: "Footer", path: "/admin/footer-editor", icon: "footer" },
        { label: "Visa Detail", path: "/admin/visa-detail-editor", icon: "visa" },
        { label: "Refund Policy", path: "/admin/refund-policy-editor", icon: "refund" },
        { label: "Requirements", path: "/admin/requirements-editor", icon: "content" },
        { label: "Government Fee", path: "/admin/govt-fee-history-editor", icon: "content" },
        { label: "Hero", path: "/admin/hero-editor", icon: "content" },
        { label: "Events", path: "/admin/event-editor", icon: "content" },
        { label: "Passport Buddy", path: "/admin/passport-editor", icon: "content" },
        {
          label: "Meeting",
          path: "/admin/schedule-meeting-editor",
          icon: "content",
          children: [
            { label: "Schedule Meeting", path: "/admin/schedule-meeting-editor", icon: "content" },
            { label: "Meeting Bookings", path: "/admin/meeting-bookings", icon: "content" },
          ],
        },
        {
          label: "Career",
          path: "/admin/visa-career-editor",
          icon: "content",
          children: [
            { label: "Visa Career", path: "/admin/visa-career-editor", icon: "content" },
            { label: "Job Applications", path: "/admin/job-applications", icon: "content" },
          ],
        },
      ],
    },
    {
      label: "Changes",
      path: "/admin/staff-changes",
      icon: "changes",
      children: [
        { label: "Staff Changes", path: "/admin/staff-changes", icon: "people" },
        { label: "Manager Changes", path: "/admin/manager-changes", icon: "people" },
        { label: "My Changes", path: "/admin/my-changes", icon: "history" },
      ],
    },
    { label: "Login History", path: "/admin/login-history", icon: "history" },
    { label: "Notifications", path: "/admin/notifications", icon: "bell" },
  ],
  Manager: [
    { label: "Dashboard", path: "/manager/dashboard", icon: "dashboard" },
    {
      label: "Review",
      path: "/manager/refund-ratings",
      icon: "star",
      children: [
        { label: "Refund Review", path: "/manager/refund-ratings", icon: "star" },
      ],
    },
    { label: "Email Settings", path: "/manager/email-settings", icon: "email" },
    {
      label: "Content",
      path: "/manager/content-manager",
      icon: "content",
      children: [
        { label: "Navbar", path: "/manager/navbar-editor", icon: "navbar" },
        { label: "Footer", path: "/manager/footer-editor", icon: "footer" },
        { label: "Visa Detail", path: "/manager/visa-detail-editor", icon: "visa" },
        { label: "Refund Policy", path: "/manager/refund-policy-editor", icon: "refund" },
        { label: "Requirements", path: "/manager/requirements-editor", icon: "content" },
        { label: "Government Fee", path: "/manager/govt-fee-history-editor", icon: "content" },
        { label: "Hero", path: "/manager/hero-editor", icon: "content" },
        { label: "Events", path: "/manager/event-editor", icon: "content" },
        { label: "Passport Buddy", path: "/manager/passport-editor", icon: "content" },
        {
          label: "Meeting",
          path: "/manager/schedule-meeting-editor",
          icon: "content",
          children: [
            { label: "Schedule Meeting", path: "/manager/schedule-meeting-editor", icon: "content" },
            { label: "Meeting Bookings", path: "/manager/meeting-bookings", icon: "content" },
          ],
        },
        {
          label: "Career",
          path: "/manager/visa-career-editor",
          icon: "content",
          children: [
            { label: "Visa Career", path: "/manager/visa-career-editor", icon: "content" },
            { label: "Job Applications", path: "/manager/job-applications", icon: "content" },
          ],
        },
      ],
    },
    {
      label: "Changes",
      path: "/manager/staff-changes",
      icon: "changes",
      children: [
        { label: "Staff Changes", path: "/manager/staff-changes", icon: "people" },
        { label: "My Changes", path: "/manager/my-changes", icon: "history" },
      ],
    },
    { label: "Login History", path: "/manager/login-history", icon: "history" },
    { label: "Notifications", path: "/manager/notifications", icon: "bell" },
  ],
  Staff: [
    { label: "Dashboard", path: "/staff/dashboard", icon: "dashboard" },
    { label: "Email Settings", path: "/staff/email-settings", icon: "email" },
    {
      label: "Content",
      path: "/staff/content-manager",
      icon: "content",
      children: [
        { label: "Navbar", path: "/staff/navbar-editor", icon: "navbar" },
        { label: "Footer", path: "/staff/footer-editor", icon: "footer" },
        { label: "Visa Detail", path: "/staff/visa-detail-editor", icon: "visa" },
        { label: "Refund Policy", path: "/staff/refund-policy-editor", icon: "refund" },
        { label: "Requirements", path: "/staff/requirements-editor", icon: "content" },
        { label: "Government Fee", path: "/staff/govt-fee-history-editor", icon: "content" },
        { label: "Hero", path: "/staff/hero-editor", icon: "content" },
        { label: "Events", path: "/staff/event-editor", icon: "content" },
        { label: "Passport Buddy", path: "/staff/passport-editor", icon: "content" },
        {
          label: "Meeting",
          path: "/staff/schedule-meeting-editor",
          icon: "content",
          children: [
            { label: "Schedule Meeting", path: "/staff/schedule-meeting-editor", icon: "content" },
            { label: "Meeting Bookings", path: "/staff/meeting-bookings", icon: "content" },
          ],
        },
        {
          label: "Career",
          path: "/staff/visa-career-editor",
          icon: "content",
          children: [
            { label: "Visa Career", path: "/staff/visa-career-editor", icon: "content" },
            { label: "Job Applications", path: "/staff/job-applications", icon: "content" },
          ],
        },
      ],
    },
    { label: "My Changes", path: "/staff/my-changes", icon: "changes" },
    { label: "Submit Change", path: "/staff/submit-change", icon: "add" },
    { label: "Notifications", path: "/staff/notifications", icon: "bell" },
  ],
};
